module.exports = __webpack_public_path__ + "static/media/facebook-button.bdfc2fe5.png";